module.exports = __webpack_public_path__ + "static/media/recurring_completed.61687da8.svg";